'use client';

import React from 'react';

import { useRouter } from 'next/navigation';

import HowItWorksStepper from '@modules/home/component/sections/HowItWorksStepper';
import { paths } from '@routes/path';

import { CompanyLogoCarousal } from '../sections/CompanyLogoCarousal';
import ExploreMentorshipDomains from '../sections/ExploreMentorshipDomains';
import FAQSection from '../sections/Faq';
import HomeTopSection from '../sections/HomeTopSection';
import LinearImages from '../sections/LinearImages';
import { MentorIcon } from '../sections/MentorIcon';
// import Partner from '../sections/Partners';
import Quotes from '../sections/Quotes';
import { StalingCard } from '../sections/StalingCard';
import { TopMentors } from '../sections/TopMentors';
import { WhyChooseYourYoda } from '../sections/WhyChooseYourYoda';

const HomePageView = () => {
    const router = useRouter();
    const handleMentor = () => {
        router.push(paths.mentor.auth.signup);
    };
    return (
        <>
            <HomeTopSection />
            <CompanyLogoCarousal />
            <ExploreMentorshipDomains />
            <TopMentors />
            {/* <Partner /> */}
            <WhyChooseYourYoda />
            <StalingCard />
            <HowItWorksStepper />
            <MentorIcon />
            <Quotes />
            <LinearImages
                heading="Inspire and Impact Lives by Sharing Your Expertise with Aspiring Minds"
                buttonLabel="Become a Mentor"
                onClick={handleMentor}
            />
            <FAQSection />
            {/* <Member /> */}
            {/* <LinearMentor /> */}
        </>
    );
};
export default HomePageView;
